import moment from 'moment';
import Cookies from 'universal-cookie';
import { t } from 'utils/translates';

const cookies = new Cookies();

// TODO Когда потребуется тут описать получение локали пользователя для организации мультиязычности moment
export const getLocal = () => {
  const lang = cookies.get('locale');
  return lang || 'ru-RU';
};

// Подмена переданного значения если оно пустое
export const emptyReplace = (data, replace = '-') => {
  if (data !== null && data !== undefined && data !== '') {
    return data;
  }
  return replace;
};

// Получение кол-ва лет с переданной даты
export const numberOfYears = date => {
  if (date) {
    return moment().diff(date, 'years', false);
  }
  return undefined;
};

// Форматирования дат
export const dateFormat1 = date => {
  const locale = getLocal();
  return moment(date)
    .locale(locale)
    .format(locale === 'ru-RU' ? 'DD.MM.YY в HH:mm' : 'DD.MM.YY in HH:mm');
};

export const dateFormat2 = date =>
  moment(date)
    .locale(getLocal())
    .format('LLLL');

export const dateFormat3 = date =>
  moment(date)
    .locale(getLocal())
    .format('DD.MM.YY');

export const dateFormat4 = date =>
  moment(date)
    .locale(getLocal())
    .format('DD.MM.YYYY');

export const dateFormat5 = date =>
  moment(date)
    .locale(getLocal())
    .format('DD.MM.YY HH:mm');

export const dateFormat7 = date =>
  moment(date)
    .locale(getLocal())
    .format('LL');

export const dateFormatSql = date =>
  moment(date)
    .locale(getLocal())
    .format('YYYY-MM-DD');

export const formattedMinutes = minutes => {
  if (minutes < 60) {
    return t('{minutes} мин.', { minutes });
  } else if (minutes < 1440) {
    const hours = (minutes / 60).toFixed();
    return t('{hours} час.', { hours });
  } else if (minutes >= 1440) {
    const days = (minutes / 60 / 24).toFixed();
    return t('{days} дн.', { days });
  }
  return t('{minutes} мин.', { minutes });
};

export const numberFormat = (number, grouping = true) => {
  const formatter = new Intl.NumberFormat('ru-RU', {
    style: 'decimal',
    minimumFractionDigits: 0,
    maximumFractionDigits: 4,
    useGrouping: grouping
  });
  return formatter.format(number);
};

export const moneyFormat = (sum, currency) => {
  try {
    const formatter = new Intl.NumberFormat('ru-RU', {
      style: 'currency',
      currency: currency || 'RUB',
      currencyDisplay: 'code',
      minimumFractionDigits: 0,
      maximumFractionDigits: 4
    });
    return formatter.format(sum);
  } catch (e) {
    return `${numberFormat(sum)} ${currency || 'RUB'}`;
  }
};



// WEBPACK FOOTER //
// ./src/mt-react-common/utils/formatter.js